import { render, staticRenderFns } from "./formAddress.vue?vue&type=template&id=87b74870&scoped=true"
import script from "./formAddress.vue?vue&type=script&lang=js"
export * from "./formAddress.vue?vue&type=script&lang=js"
import style0 from "./formAddress.vue?vue&type=style&index=0&id=87b74870&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b74870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b74870')) {
      api.createRecord('87b74870', component.options)
    } else {
      api.reload('87b74870', component.options)
    }
    module.hot.accept("./formAddress.vue?vue&type=template&id=87b74870&scoped=true", function () {
      api.rerender('87b74870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/formAddress.vue"
export default component.exports